import { createApp } from 'vue';
import GlobalChatbot from '../components/GlobalChatbot.vue';

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.server) return;

    // Create and mount the GlobalChatbot component
    const chatbotContainer = document.createElement('div');
    document.body.appendChild(chatbotContainer);
    const chatbotApp = createApp(GlobalChatbot);
    const chatbotInstance = chatbotApp.mount(chatbotContainer);

    return {
        provide: {
            toggleChatbot: (show) => {
                if (chatbotInstance && typeof chatbotInstance.toggleVisibility === 'function') {
                    chatbotInstance.toggleVisibility(show);
                }
            }
        }
    }
}); 